import axios from 'axios'
import botconfig from './botconfig'

export async function fetchGuilds(userId, access_token) {
    try {
        const responseGuilds = await axios({
            url: `${botconfig.api_path}${botconfig.api_port}/api/users/${userId}/servers`,
            method: "get",
            headers: { "authorization": `${access_token}` }
        }).then(response => {
            return response.data
        })
        return responseGuilds
    } catch (err) {
        throw err
    }
}
export async function saveItem(item, token, userId) {
    try {
        const response = await axios({
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${item.guildID}/items/${item.itemID}/save`,
            method: "post",
            headers: {
                authorization: token,
                userId
            },
            data: item
        }).then(response => response.data)
        return response
    } catch (err) {
        throw err
    }
}
export async function fetchEmojis(token) {
    try {
        const response = await axios({
            url: `${botconfig.api_path}${botconfig.api_port}/api/emojis`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => response.data)
        return response
    } catch (err) {
        throw err
    }
}
export async function login({ grant_type, code, refresh_token, redirect_uri }) {
    await axios({
        url: `${botconfig.api_path}${botconfig.api_port}/api/oauth2/token`,
        method: "post",
        data: {
            grant_type,
            client_id: botconfig.botId,
            code: code,
            refresh_token,
            redirect_uri
        }
    }).then(async response => {
        const token = response.data
        await axios({
            url: "https://discord.com/api/users/@me",
            method: "get",
            headers: { "Authorization": `${token.token_type} ${token.access_token}` }
        }).then(async response => {
            const user = response.data
            await axios({
                url: `${botconfig.api_path}${botconfig.api_port}/api/users/${user.id}`,
                method: "post",
                headers: { "Authorization": token.access_token }
            })
            const localItem = JSON.parse(localStorage.getItem("wetbot"))
            let lang = user.locale
            if (user.locale === "uk") lang = "ru"
            else if (user.locale === "en-US") lang = "en-GB"
            else if (user.locale !== "ru" && user.locale !== "en-GB") lang = "en-GB"
            localStorage.setItem("wetbot", JSON.stringify({ token, user, ...localItem }))
            localStorage.setItem("language", lang)
            await fetchGuilds(user.id, token.access_token)
        }).catch(e => {
            throw e
        })
    }).catch(e => {
        throw e
    })
}
export async function fetchProfile(guildId, userId, token) {
    try {
        const response = await axios({
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/profiles/${userId}`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => response.data)
        return response
    } catch (err) {
        throw err
    }
}
export async function fetchGuild(guildId, token) {
    try {
        const response = await axios({
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => response.data)
        return response
    } catch (err) {
        throw err
    }
}
export async function fetchSettings(guildId, token) {
    try {
        const response = await axios({
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/settings`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => response.data)
        return response
    } catch (err) {
        throw err
    }
}
export async function fetchGuildItems(guildId, token) {
    try {
        const responseItems = await axios({ 
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/items`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => {
            return response.data.response
        })
        return responseItems.map(item => {
            return {
                ...item,
                shop: {
                    ...item.shop,
                    amount: item.shop.amount === null ? Infinity : item.shop.amount
                }
            }
        })
    } catch (err) {
        throw err
    }
}
export async function fetchGuildAchievements(guildId, token) {
    try {
        const response = await axios({
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/achievements`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => {
            return response.data.response
        })
        return response
    } catch (err) {
        throw err
    }
}
export async function saveProfile(userId, guildId, changed, token) {
    try {
        const response = await axios({
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/profiles/${userId}/save`,
            method: "post",
            headers: {
                authorization: token
            },
            data: {
                ...changed
            }
        }).then(response => response.data)
        return response
    } catch (err) {
        throw err
    }
}
export async function fetchUser(token) {
    return await axios({
        url: "https://discord.com/api/users/@me",
        method: "get",
        headers: { "Authorization": `${token.token_type} ${token.access_token}` }
    }).then(async response => {
        const user = response.data
        return user
    }).catch(e => {
        throw e
    })
}
export async function fetchGuildCategories(guildId, token) {
    try {
        const responseCategories = await axios({ 
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/categories`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => {
            return response.data.response
        })
        return responseCategories
    } catch (err) {
        throw err
    }
}
export async function fetchGuildGifts(guildId, token) {
    try {
        const responseGifts = await axios({ 
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/gifts`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => {
            return response.data.response
        })
        return responseGifts
    } catch (err) {
        throw err
    }
}
export async function fetchGuildPermissions(guildId, token) {
    try {
        const responsePermissions = await axios({ 
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/permissions`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => {
            return response.data.response
        })
        return responsePermissions
    } catch (err) {
        throw err
    }
}
export async function fetchGuildPromocodes(guildId, token) {
    try {
        const responsePromocodes = await axios({ 
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/promocodes`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => {
            return response.data.response
        })
        return responsePromocodes
    } catch (err) {
        throw err
    }
}
export async function fetchGuildQuests(guildId, token) {
    try {
        const responseQuests = await axios({ 
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/quests`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => {
            return response.data.response
        })
        return responseQuests
    } catch (err) {
        throw err
    }
}
export async function fetchGuildJobs(guildId, token) {
    try {
        const responseJobs = await axios({ 
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/jobs`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => {
            return response.data.response
        })
        return responseJobs
    } catch (err) {
        throw err
    }
}
export async function fetchGuildIncomeRoles(guildId, token) {
    try {
        const responseIncomeRoles = await axios({ 
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/income-roles`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => {
            return response.data.response
        })
        return responseIncomeRoles
    } catch (err) {
        throw err
    }
}
export async function fetchGuildStyles(guildId, token) {
    try {
        const responseStyles = await axios({ 
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/styles`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => {
            return response.data.response
        })
        return responseStyles
    } catch (err) {
        throw err
    }
}
export async function fetchGuildWormholes(guildId, token) {
    try {
        const responseWormholes = await axios({ 
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/wormholes`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => {
            return response.data.response
        })
        return responseWormholes
    } catch (err) {
        throw err
    }
}
export async function fetchGuildAutogenerators(guildId, token) {
    try {
        const responseAutogenerators = await axios({ 
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/autogenerators`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => {
            return response.data.response
        })
        return responseAutogenerators
    } catch (err) {
        throw err
    }
}
export async function fetchGuildBonusChannels(guildId, token) {
    try {
        const responseBonusChannels = await axios({ 
            url: `${botconfig.api_path}${botconfig.api_port}/api/private/guilds/${guildId}/bonus-channels`,
            method: "get",
            headers: {
                authorization: token
            }
        }).then(response => {
            return response.data.response
        })
        return responseBonusChannels
    } catch (err) {
        throw err
    }
}